import { buildKitchenEstimateCfn, type Kitchen } from '@rta/rta-blueprint-library';

import { getEstimatedTax } from '@helpers';
import type { CustomerState, Project } from '@state';
import type { PresentationPricingPayload } from '../upload-presentation-design';

export type BuildPresentationEstimateParams = {
	kitchen: Kitchen;
	customer: CustomerState;
	project: Array<Project>;
	dealId?: string;
};

const formatTaxRateLabel = (rate: number): string => `${(rate * 100).toFixed(2)}%`;

// Pre-tax rollup comes from the ONE shared library implementation; this adapter only adds the ZIP-table tax the in-tool estimate uses
export const buildPresentationEstimate = (params: BuildPresentationEstimateParams): PresentationPricingPayload => {
	const { kitchen, customer, project, dealId } = params;

	const estimate = buildKitchenEstimateCfn(kitchen);
	const { tax, taxRate, taxNote, state: taxState } = getEstimatedTax({ kitchen, customer, project, dealId });

	return {
		...estimate,
		tax,
		taxRate,
		taxState: taxState || undefined,
		taxNote,
		taxRateLabel: formatTaxRateLabel(taxRate),
		total: estimate.subtotal + tax
	};
};
